import HandCurrencyIcon from './HandCurrencyIcon'

export default HandCurrencyIcon
